import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Grid,
    MenuItem,
    Collapse,
    Switch,
    Divider,
    Tab,
    Tabs
} from '@mui/material';
import {
    InventoryOutlined as InventoryIcon,
    CollectionsOutlined as CollectionsIcon,
    KeyboardArrowDown as ArrowDownIcon,
    KeyboardArrowUp as ArrowUpIcon,
    Check
} from '@mui/icons-material';
import LayersIcon from '@mui/icons-material/Layers';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { apiUrl } from '../../comp/ApiUrl';
import { WithRouter } from '../../comp/WithRouter';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

class EditPriceProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quantidade: 1,
            precoVenda: 0,
            precoOriginal: 0,
            precoSobConsulta: false,

            // Configurar preço de atacado
            expandidoAtacado: false,
            venderAtacado: false,
            exibirApenasAtacado: false,
            precoAtacado: '',
            qtdMinima: 3,
            unidade: 'UN',

            isSaving: false
        };
    }

    componentDidMount() {
        document.title = 'Editar Preço do Produto';
        this.buscarDadosPreco();
    }

    buscarDadosPreco = () => {
        fetch(`${apiUrl}/produtos/get/price/${this.props.params.uuid}`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                throw new Error("Erro ao carregar dados de preço");
            })
            .then((data) => {

                this.setState({
                    quantidade: data.quantidade ?? 1,
                    precoVenda: data.preco || 0,
                    precoOriginal: data.custo || 0,
                    precoSobConsulta: data.precoSobConsulta || false,
                    venderAtacado: data.venderAtacado || false,
                    exibirApenasAtacado: data.exibirApenasAtacado || false,
                    precoAtacado: data.precoAtacado || '',
                    qtdMinima: data.qtdMinima || 3,
                    unidade: data.unidade || 'UN'
                });
            })
            .catch((error) => {
                console.error("Erro ao buscar produto:", error);
                toast.error("Erro ao carregar dados do produto.");
            });
    };

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleSwitchChange = (event) => {
        const { name, checked } = event.target;
        this.setState({ [name]: checked });
    };

    handleSalvar = async () => {
        const {
            quantidade,
            precoVenda,
            precoOriginal,
            precoSobConsulta,
            venderAtacado,
            exibirApenasAtacado,
            precoAtacado,
            qtdMinima,
            unidade
        } = this.state;

        const toastId = toast.loading("Salvando dados de preço...");
        this.setState({ isSaving: true });

        try {
            const response = await fetch(`${apiUrl}/products/set/v2/price`, {
                method: "PUT",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    uuid: this.props.params.uuid,
                    quantidade,
                    precoVenda,
                    precoOriginal,
                    precoSobConsulta,
                    venderAtacado,
                    exibirApenasAtacado,
                    precoAtacado,
                    qtdMinima,
                    unidade
                }),
            });

            const data = await response.json();

            if (data.success) {
                toast.update(toastId, {
                    render: "Preço e estoque salvos com sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 3000
                });
            } else {
                throw new Error(data.error || "Erro ao salvar alterações.");
            }
        } catch (error) {
            console.error("Erro ao salvar preço:", error);
            toast.update(toastId, {
                render: error.message || "Falha ao salvar dados de preço.",
                type: "error",
                isLoading: false,
                autoClose: 3000
            });
        } finally {
            this.setState({ isSaving: false });
        }
    };

    render() {
        const {
            quantidade,
            precoVenda,
            precoOriginal,
            precoSobConsulta,
            expandidoAtacado,
            venderAtacado,
            exibirApenasAtacado,
            precoAtacado,
            qtdMinima,
            unidade,
            isSaving
        } = this.state;

        const inputStyle = {
            '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc',
                borderRadius: 2,
                '& fieldset': { borderColor: '#e2e8f0' },
                '&:hover fieldset': { borderColor: '#cbd5e1' },
                '&.Mui-focused fieldset': { borderColor: '#9966f1' }
            },
            '& .MuiOutlinedInput-input::placeholder': {
                color: '#94a3b8',
                opacity: 1
            }
        };

        return (
            <Box sx={{ p: 0, backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                {/* Topbar */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4 }}>
                    <Box>
                        <Typography variant="h5" fontWeight="700" gutterBottom>
                            Editar Produto
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Gerencie os preços e o estoque do produto
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        onClick={this.handleSalvar}
                        disabled={isSaving}
                        startIcon={<Check />}
                        sx={{ borderRadius: '8px', textTransform: 'none' }}
                    >
                        Salvar Preço
                    </Button>
                </Box>

                {/* Tabs */}
                <Box sx={{ mb: 4 }}>
                    <Tabs
                        value={2} // Ou gerencie dinamicamente com base na rota
                        onChange={this.handleTabChange}
                        variant="scrollable" // Permite rolagem lateral no mobile
                        scrollButtons="auto" // Exibe setas de navegação quando necessário
                        allowScrollButtonsMobile // Garante que as setas ou scroll funcionem bem em touch screens
                        sx={{
                            '& .MuiTabs-indicator': { display: 'none' },
                            '& .MuiTabs-scroller': {
                                overflowX: 'auto', // Permite scroll suave
                            },
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                minHeight: '40px',
                                borderRadius: '8px',
                                mr: 1,
                                fontWeight: 500,
                                color: '#666',
                                whiteSpace: 'nowrap', // Impede que o texto quebre em várias linhas no mobile
                                flexShrink: 0 // Evita que as abas fiquem espremidas
                            },
                            '& .Mui-selected': {
                                bgcolor: '#fff',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                color: '#000 !important'
                            }
                        }}
                    >
                        <Tab
                            component={Link}
                            to={`/produtos/${this.props.params.uuid}/basic`}
                            icon={<InventoryIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Informações Básicas"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${this.props.params.uuid}/photos`}
                            icon={<CollectionsIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Fotos do Produto"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${this.props.params.uuid}/price`}
                            icon={<AttachMoneyIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Preço"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${this.props.params.uuid}/attributes`}
                            icon={<LayersIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Atributos & Variações"
                        />
                    </Tabs>
                </Box>

                {/* Card de Preço */}
                <Card sx={{ mt: 3, borderRadius: 3, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)', border: '1px solid #e2e8f0' }}>
                    <CardContent sx={{ p: 3 }}>
                        {/* Header do Card */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                            <Box sx={{ bgcolor: '#e8f5e9', p: 1, borderRadius: 2, display: 'flex' }}>
                                <AttachMoneyIcon sx={{ color: '#2e7d32' }} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                    Preço & Estoque
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    Ajuste os valores de venda, custo e opções de atacado
                                </Typography>
                            </Box>
                        </Box>

                        {/* Linha 1: Estoque, Preço de Venda e Preço Original */}
                        <Grid container spacing={2} sx={{ mb: 2.5 }}>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                    Estoque <span style={{ color: '#ef4444' }}>*</span>
                                </Typography>
                                <TextField
                                    fullWidth
                                    type="number"
                                    name="quantidade"
                                    value={quantidade === '' ? '' : quantidade}
                                    onChange={(event) => {
                                        const val = parseInt(event.target.value);
                                        this.setState({ quantidade: isNaN(val) || val < 1 ? 1 : val });
                                    }}
                                    inputProps={{ min: 1 }}
                                    variant="outlined"
                                    size="small"
                                    sx={inputStyle}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                    Preço de venda <span style={{ color: '#ef4444' }}>*</span>
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="precoVenda"
                                    value={precoVenda ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(precoVenda) : ""}
                                    onChange={(event) => {
                                        const cleanValue = event.target.value.replace(/\D/g, "");
                                        const numberValue = cleanValue ? parseFloat(cleanValue) / 100 : 0;
                                        this.setState({ precoVenda: numberValue });
                                    }}
                                    placeholder="R$ 0,00"
                                    variant="outlined"
                                    size="small"
                                    sx={inputStyle}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#475569' }}>
                                    Preço original <span style={{ color: '#94a3b8', fontWeight: 'normal' }}>(opcional)</span>
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="precoOriginal"
                                    value={precoOriginal ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(precoOriginal) : ""}
                                    onChange={(event) => {
                                        const cleanValue = event.target.value.replace(/\D/g, "");
                                        const numberValue = cleanValue ? parseFloat(cleanValue) / 100 : 0;
                                        this.setState({ precoOriginal: numberValue });
                                    }}
                                    placeholder="R$ 0,00"
                                    variant="outlined"
                                    size="small"
                                    sx={inputStyle}
                                />
                            </Grid>
                        </Grid>

                        {/* Switch: Preço sob consulta */}
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                bgcolor: '#f8fafc',
                                p: 1.5,
                                borderRadius: 2,
                                border: '1px solid #e2e8f0',
                                mb: 3
                            }}
                        >
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: '600', color: '#1e293b' }}>
                                    Preço sob consulta
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    Clientes verão "Consulte o preço" em vez do valor
                                </Typography>
                            </Box>
                            <Switch
                                name="precoSobConsulta"
                                checked={precoSobConsulta}
                                onChange={this.handleSwitchChange}
                                color="secondary"
                                sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#7c3aed' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#7c3aed' } }}
                            />
                        </Box>

                        {/* Gatilho Sanfonado Atacado */}
                        <Box sx={{ mb: 1 }}>
                            <Button
                                onClick={() => this.setState({ expandidoAtacado: !expandidoAtacado })}
                                startIcon={expandidoAtacado ? <ArrowUpIcon fontSize="small" /> : <ArrowDownIcon fontSize="small" />}
                                sx={{
                                    textTransform: 'none',
                                    color: '#64748b',
                                    fontWeight: '500',
                                    fontSize: '0.875rem',
                                    p: 0,
                                    '&:hover': { bgcolor: 'transparent', color: '#475569' }
                                }}
                            >
                                Configurar preço de atacado
                            </Button>
                        </Box>

                        {/* Seção Sanfonada do Atacado */}
                        <Collapse in={expandidoAtacado}>
                            <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 3, p: 2.5, mt: 1.5, bgcolor: '#fff' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                    <Typography variant="body1" sx={{ fontWeight: '600', color: '#1e293b' }}>
                                        Vender no atacado?
                                    </Typography>
                                    <Switch
                                        name="venderAtacado"
                                        checked={venderAtacado}
                                        onChange={this.handleSwitchChange}
                                        sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#7c3aed' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#7c3aed' } }}
                                    />
                                </Box>

                                <Collapse in={venderAtacado}>
                                    <Divider sx={{ my: 2, borderColor: '#e2e8f0' }} />

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            bgcolor: '#f8fafc',
                                            p: 1.5,
                                            borderRadius: 2,
                                            border: '1px solid #e2e8f0',
                                            mb: 3
                                        }}
                                    >
                                        <Box>
                                            <Typography variant="body2" sx={{ fontWeight: '600', color: '#1e293b' }}>
                                                Exibir apenas preço de atacado
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                Produto vendido somente no atacado
                                            </Typography>
                                        </Box>
                                        <Switch
                                            name="exibirApenasAtacado"
                                            checked={exibirApenasAtacado}
                                            onChange={this.handleSwitchChange}
                                            size="small"
                                        />
                                    </Box>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                                Preço atacado
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                name="precoAtacado"
                                                value={precoAtacado}
                                                onChange={this.handleInputChange}
                                                placeholder="R$ 0,00"
                                                variant="outlined"
                                                size="small"
                                                sx={inputStyle}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                                Qtd. mínima
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                name="qtdMinima"
                                                value={qtdMinima}
                                                onChange={this.handleInputChange}
                                                variant="outlined"
                                                size="small"
                                                sx={inputStyle}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                                Unidade
                                            </Typography>
                                            <TextField
                                                select
                                                fullWidth
                                                name="unidade"
                                                value={unidade}
                                                onChange={this.handleInputChange}
                                                variant="outlined"
                                                size="small"
                                                sx={inputStyle}
                                            >
                                                <MenuItem value="UN">UN</MenuItem>
                                                <MenuItem value="PC">PC</MenuItem>
                                                <MenuItem value="KG">KG</MenuItem>
                                            </TextField>
                                        </Grid>
                                    </Grid>
                                </Collapse>
                            </Box>
                        </Collapse>
                    </CardContent>
                </Card>
            </Box>
        );
    }
}

export default WithRouter(EditPriceProduct);